import { http } from '@/api/http';
import { ApiResponseBody, PaginatedApiResponseBody, PaginationSearchParams } from '@/api/types';
import { Hospital, NewHospitalFormBody, PatchHospitalFormBody } from './hospital.types';
import { getHospitalApiUrl } from './hospital.paths';
import {
  Contact,
  NewHospitalContactFormBody,
  PaginatedHospitalContactListQueryParams,
  PatchHospitalContactFormBody,
} from '@/api/apis/facilities';

const getHospitalList = async (params: PaginationSearchParams) => {
  const res = await http.get<PaginatedApiResponseBody<Hospital>>(getHospitalApiUrl.list(), { params });
  return res.data.data;
};

const createHospital = async (body: NewHospitalFormBody & { id: string }) => {
  const res = await http.post<ApiResponseBody<Hospital>>(getHospitalApiUrl.list(), body);
  return res.data.data;
};

const updateHospitalById = async ({ id, ...body }: PatchHospitalFormBody & { id: string }) => {
  const res = await http.patch<ApiResponseBody<Hospital>>(getHospitalApiUrl.hospitalById(id), body);
  return res.data.data;
};

const getHospitalById = async (hospitalId: string): Promise<Hospital> => {
  const res = await http.get<ApiResponseBody<Hospital>>(getHospitalApiUrl.hospitalById(hospitalId));
  return res.data.data;
};

const getHospitalContactList = async (params: PaginatedHospitalContactListQueryParams) => {
  const res = await http.get<PaginatedApiResponseBody<Contact>>(getHospitalApiUrl.hospitalContacts(), { params });
  return res.data.data;
};

const getHospitalContactById = async (contactId: string) => {
  const res = await http.get<ApiResponseBody<Contact>>(getHospitalApiUrl.hospitalContactById(contactId));
  return res.data.data;
};

const createHospitalContact = async (hospitalId: string, body: NewHospitalContactFormBody) => {
  const res = await http.post<ApiResponseBody<Contact>>(
    getHospitalApiUrl.hospitalContactsByHospitalId(hospitalId),
    body,
  );
  return res.data.data;
};

const updateHospitalContact = async ({ id, ...body }: PatchHospitalContactFormBody & { id: string }) => {
  const res = await http.patch<ApiResponseBody<Contact | { message: string }>>(
    getHospitalApiUrl.hospitalContactById(id),
    body,
  );
  return res.data.data;
};

export const hospitalApiFetcher = {
  getHospitalList,
  getHospitalById,
  createHospital,
  updateHospitalById,
  getHospitalContactList,
  getHospitalContactById,
  createHospitalContact,
  updateHospitalContact,
};
